import React from 'react';

import { useOperatorAuth } from '@contexts/operator/OperatorAuthContext';
import { Spin } from 'antd';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * AuthGuard - 保護需要認證的路由
 */
export const AuthGuard = ({ children }) => {
  const { isAuthenticated, loading } = useOperatorAuth();
  const location = useLocation();

  // 等待認證檢查
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  // 未登入，導向登入頁
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 已認證，允許訪問
  return children;
};

/**
 * GuestGuard - 保護登入頁面（已登入用戶不應該看到登入頁）
 */
export const GuestGuard = ({ children }) => {
  const { isAuthenticated, loading, operator } = useOperatorAuth();

  // 等待認證檢查
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  // 已登入，導向對應頁面
  if (isAuthenticated) {
    if (operator?.totp_setup_required) {
      return <Navigate to="/totp-setup" replace />;
    }
    return <Navigate to="/products" replace />;
  }

  // 未登入，顯示登入頁面
  return children;
};
